import Vue from "vue";
import VueRouter from "vue-router";
import oauthRoutes from "./modules/oauth";
Vue.use(VueRouter);

const routes = [
  // OAuth 独立路由体系（/oauth/login、/oauth/authorize）
  oauthRoutes,
  {
    path: "/",
    name: "home",
    component: () => import("@/views/home/index.vue"),
    meta: { requiresAuth: false, noHeader: true, name: "导航搜索-首页" }, // 首页使用设计稿自带头部
  },
  {
    path: "/h5",
    name: "h5",
    component: () => import("@/views/h5/index.vue"),
    meta: { requiresAuth: false, noHeader: true, name: "导航搜索-移动端首页" }, // 首页使用设计稿自带头部
  },
  {
    path: "/coupon/:code",
    name: "coupon",
    component: () => import("@/views/coupon/index.vue"),
    meta: { requiresAuth: false, name: "Tushare 专属优惠券" },
  },
  {
    path: "/login",
    // alias: '/register',
    name: "login",
    component: () => import("@/views/login/index.vue"),
    meta: { requiresAuth: false, noHeader: true }, // 登录页面不需要验证；新版设计稿为无导航全屏页
  },
  {
    path: "/combo",
    // alias: '/register',
    name: "combo",
    component: () => import("@/views/combo/index.vue"),
    meta: { requiresAuth: false, name: "导航搜索-活动套餐" }, // 登录页面不需要验证
  },
  {
    path: "/permission",
    name: "permission",
    component: () => import("@/views/permission/index.vue"),
    redirect: "/permission/buy",
    meta: { requiresAuth: true, name: "导航搜索-权限中心" },
    children: [
      {
        path: "buy",
        name: "buy",
        component: () => import("@/views/permission/buy/index.vue"),
        meta: { requiresAuth: true, name: "导航搜索-权限中心" },
      },
      {
        path: "order",
        name: "order",
        component: () => import("@/views/permission/order/index.vue"),
        meta: { requiresAuth: true, name: "导航搜索-权限中心" },
      },
      {
        path: "invoice",
        name: "invoice",
        component: () => import("@/views/permission/invoice/index.vue"),
        meta: { requiresAuth: true, name: "导航搜索-我的发票" },
      },
      {
        path: "coupons",
        name: "myCoupons",
        component: () => import("@/views/permission/coupons/index.vue"),
        meta: { requiresAuth: true, name: "导航搜索-权限中心-我的优惠券" },
      },
    ],
  },
  {
    path: "/invoiceDetails/:id",
    name: "invoiceDetails",
    component: () => import("@/views/invoiceDetails/index.vue"),
    meta: { requiresAuth: true, name: "导航搜索-我的发票" },
  },
  {
    path: "/activity/:id",
    name: "activity",
    component: () => import("@/views/activity/index.vue"),
    meta: { requiresAuth: true, name: "导航搜索-活动套餐" },
  },
  {
    path: "/user",
    name: "user",
    component: () => import("@/views/user/index.vue"),
    redirect: "/user/privilege",
    meta: { requiresAuth: true, name: "导航搜索-个人中心" },
    children: [
      {
        path: "privilege",
        name: "privilege",
        component: () => import("@/views/user/privilege/index.vue"),
        meta: { requiresAuth: true, name: "导航搜索-个人中心" },
      },
      {
        path: "info",
        name: "info",
        component: () => import("@/views/user/info/index.vue"),
        meta: { requiresAuth: true, name: "导航搜索-个人中心" },
      },
      {
        path: "mcp",
        name: "mcp",
        component: () => import("@/views/user/mcp/index.vue"),
        meta: { requiresAuth: true, name: "导航搜索-个人中心" },
      },
    ],
  },
];

const router = new VueRouter({
  mode: "hash",
  routes,
});

export default router;
